<script>
import { mapActions } from 'vuex'
import formatDollar from '@lib/utils/format-dollar'
import { formatDate } from '@lib/utils/format-date'
import orderTable from './claim-order.table.js'
import StaticProcessor from '@lib/processors/static-processor'

export default {
  name: 'ClaimOrderModal',
  props: {
    claimId: {
      type: String,
      required: true,
    },
    orderRow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      order: {},
      loaded: false,
      table: orderTable(this),
    }
  },
  computed: {
    orderId() {
      return this.orderRow.description
    },
    date() {
      return formatDate(this.orderRow.created_at, 'DD-MMM-YYYY')
    },
  },
  async created() {
    const { claimId, orderId } = this

    const [error, result] = await this.getClaimOrder({ claimId, orderId })

    if (error) {
      this.$emit('close-modal')
    } else {
      this.order = result.items
      this.table.processor = new StaticProcessor({
        component: this,
        data: this.order.items,
        disableQueryString: true,
      })

      this.loaded = true
    }
  },
  methods: {
    ...mapActions('claims', ['getClaimOrder']),
    formatDollar,
  },
}
</script>

<template>
  <div :class="$style.wrapper">
    <el-dialog
      :title="`Order details`"
      v-bind="$attrs"
      :close-on-click-modal="false"
      v-on="$listeners"
    >
      <base-loader v-if="!loaded" />
      <template v-else>
        <data-list :class="$style.list">
          <dt>Order No.</dt>
          <dd>{{ order.id }}</dd>

          <dt>Date</dt>
          <dd>{{ date }}</dd>
        </data-list>

        <table-layout
          :table-name="table.tableName"
          :fragments="false"
          :processor="table.processor"
          :columns="table.columns"
          :table-controls="false"
          :class="$style.table"
          shadow="never"
          flat
          hider
        />

        <div :class="$style.total">
          Total:
          <span :class="$style.totalNum">
            ${{ order.total }}
          </span>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
.wrapper {
  :global {
    .el-dialog {
      max-width: 45rem !important;
    }

    .el-form-item {
      .el-checkbox-group {
        width: 100%;
      }
    }

    .el-table th {
      color: var(--color-text);
      background-color: #f5f6f7;
      border-bottom: 0;
    }
  }
}

.list dt {
  min-width: 8rem;
}

.table {
  margin-top: 2rem;
  margin-bottom: 0;
  border: 0;
}

.total {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: .25rem;
  font-size: 1.4rem;
  font-weight: bold;
  color: var(--color-text);
}

.totalNum {
  margin-left: 2rem;
  font-size: 1.7rem;
}
</style>
